import React, { useState, useEffect, CSSProperties } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import "jquery-confirm/css/jquery-confirm.css";
import "jquery-confirm";
import { HISTORY_REPORT_STATUS } from "../../../../common/Constant";

// Define the DataTableProps interface
interface DataTableProps {
  headers: {
    key: string;
    label: string;
    sortable?: boolean;
    items?: any;
    style?: any;
    isNumeric?: boolean;
  }[];
  rows?: any[];
  onAction?: (action: string, row: any) => void;
  onSortAction?: (row: any, action?: string) => void;

  isLogTable?: boolean;
}

const BillingDataTable: React.FC<DataTableProps> = ({
  headers,
  rows = [],
  onAction,
  onSortAction,

  isLogTable = false,
}) => {
  const [sortedRows, setSortedRows] = useState<any[]>(rows);

  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "ASC" | "DESC" | null;
  }>({
    key: "",
    direction: null,
  });

  const handleSort = (key: string, direction: "ASC" | "DESC") => {
    if (sortConfig.key === key && sortConfig.direction === direction) {
      return; // Prevent clicking on the same active sort direction
    }
    const sorted = [...sortedRows].sort((a, b) => {
      if (direction === "ASC") {
        return a[key] > b[key] ? 1 : -1;
      }
      if (direction === "DESC") {
        return a[key] < b[key] ? 1 : -1;
      }
      return 0;
    });

    setSortedRows(sorted);
    setSortConfig({ key, direction });
    onSortAction?.({ key, direction });
  };

  return (
    <>
      <div className="table-responsive border-0 mb-2">
        <Table>
          <thead>
            <tr>
              {headers.map((header) => (
                // <th key={header.key} style={thStyle}>
                <th
                  key={header.key}
                  style={{
                    border: "none",
                    padding: "8px",
                    backgroundColor: "#e0f7fa",
                    color: "#000",
                    cursor: header.sortable ? "pointer" : "default",
                    position: "sticky",
                    top: 0,
                    zIndex: -90,

                    textAlign: ["actions"].includes(header.key)
                      ? "center"
                      : "left",
                    ...header.style,
                  }}
                >
                  <div
                    style={{
                      display: ["actions"].includes(header.key)
                        ? "flex"
                        : "flex",

                      justifyContent: ["actions"].includes(header.key)
                        ? "space-evenly"
                        : "space-between",

                      alignItems: "center",
                    }}
                  >
                    <span>{header.label}</span>
                    {header.sortable && (
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginLeft: "4px",
                          cursor: "pointer",
                          position: "absolute",
                          right: "0px",
                        }}
                      >
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "ASC"
                        ) && (
                          <span
                            className="material-icons"
                            style={{
                              fontSize: "18px",
                              lineHeight: "10px",
                            }}
                            onClick={() => handleSort(header.key, "ASC")}
                          >
                            arrow_drop_up
                          </span>
                        )}
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "DESC"
                        ) && (
                          <span
                            className="material-icons"
                            style={{
                              fontSize: "18px",
                              lineHeight: "10px",
                            }}
                            onClick={() => handleSort(header.key, "DESC")}
                          >
                            arrow_drop_down
                          </span>
                        )}
                      </span>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows?.length > 0 ? (
              rows.map((row, index) => (
                <tr
                  key={row.id}
                  style={{
                    backgroundColor: index % 2 === 1 ? "white" : "#f2f2f2",
                    position: "sticky",
                  }}
                >
                  {headers.map((header) => {
                    if (header.key === "actions") {
                      return (
                        <td
                          key={header.key}
                          style={{ padding: "8px", textAlign: "center" }}
                        >
                          {row.actions?.View && (
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                <Tooltip
                                  id={`view-tooltip-${row.id}`}
                                  style={{ backgroundColor: "#b3e0ff" }}
                                >
                                  View
                                </Tooltip>
                              }
                            >
                              <span
                                className="material-icons color_brand"
                                onClick={() => onAction?.(row, "View")}
                                style={{ cursor: "pointer" }}
                              >
                                visibility
                              </span>
                            </OverlayTrigger>
                          )}
                          {row.actions?.Edit && (
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                <Tooltip
                                  id={`edit-tooltip-${row.id}`}
                                  style={{ backgroundColor: "#b3e0ff" }}
                                >
                                  Edit
                                </Tooltip>
                              }
                            >
                              <span
                                className="material-icons color_brand"
                                onClick={() => onAction?.(row, "Edit")}
                                style={{ cursor: "pointer" }}
                              >
                                edit
                              </span>
                            </OverlayTrigger>
                          )}
                        </td>
                      );
                    }
                    if (header.key === "isActive") {
                      const isActive = row[header.key] === 1;

                      return (
                        <td
                          key={header.key}
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            color: isActive ? "green" : "red",
                            fontWeight: 500,
                          }}
                        >
                          {isActive ? "Active" : "Inactive"}
                        </td>
                      );
                    }
                    if (header.key === "rateType") {
                      const rateTypeLabel =
                        row[header.key] === "Fixed"
                          ? "Fixed"
                          : row[header.key] === "PER_PAGE"
                            ? "Per Page"
                            : row[header.key] === "PER_LINE"
                              ? "Per Line"
                              : "";

                      return (
                        <td
                          key={header.key}
                          style={{
                            padding: "8px",
                          }}
                        >
                          {rateTypeLabel}
                        </td>
                      );
                    }

                    const cellContent = row[header.key];

                    return (
                      <td
                        key={header.key}
                        style={{
                          padding: header.isNumeric
                            ? "8px 20px 8px 8px !important"
                            : "8px",
                          textAlign: header.isNumeric ? "center" : "left",
                        }}
                      >
                        <OverlayTrigger
                          placement="auto"
                          delay={{ show: 200, hide: 10 }}
                          overlay={
                            cellContent &&
                            cellContent?.length > (isLogTable ? 60 : 8) ? (
                              <Tooltip
                                id={`tooltip-${header.key}-${row.id}`}
                                style={{ backgroundColor: "#b3e0ff" }}
                              >
                                {cellContent}
                              </Tooltip>
                            ) : (
                              <></>
                            )
                          }
                        >
                          <span
                            // className= 'd-inline-block text-truncate'
                            className={`d-inline-block ${
                              !isLogTable ? "text-truncate" : ""
                            }`}
                            style={{
                              maxWidth: isLogTable ? "none" : "98%",
                              cursor: isLogTable ? "default" : "pointer",
                            }}
                          >
                            {cellContent}
                          </span>
                        </OverlayTrigger>
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers?.length} style={{ textAlign: "center" }}>
                  <span className="no_rec_data">No Record Found</span>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default BillingDataTable;
